<template>
  
  <div class="tictac">
    <div class="battlefield">

      <ul class="numbers">
        <li>1</li>
        <li>2</li>
        <li>3</li>
      </ul>

      <ul class="letters">
        <li>A</li>
        <li>B</li>
        <li>C</li>
      </ul>
        
      
      <div class="grid">

        <div class="helpers">
          <div class="winline"></div>
          <div class="hor1"></div>
          <div class="hor2"></div>
          <div class="ver1"></div>
          <div class="ver2"></div>
        </div> 
        
        <!-- ROW 1 -->
        <div class="point baby" id="A1" @click="setTarget('A1')"></div>
        <div class="point" id="A2" @click="setTarget('A2')"></div>
        <div class="point" id="A3" @click="setTarget('A3')"></div>

        <!-- ROW 2 -->
        <div class="point" id="B1" @click="setTarget('B1')"></div>
        <div class="point" id="B2" @click="setTarget('B2')"></div>
        <div class="point" id="B3" @click="setTarget('B3')"></div> 

        <!-- ROW 3 -->
        <div class="point snake" id="C1" @click="setTarget('C1')"></div>
        <div class="point you" id="C2" @click="setTarget('C2')"></div>
        <div class="point" id="C3" @click="setTarget('C3')"></div> 
      </div>

    </div>
    
    <div class="shooter">
      <div class="aim">
        <span></span>
        <div class="top"></div>
        <div class="bottom"></div>
        <div class="right"></div>
        <div class="left"></div>
      </div>

      <button class="inactive" @click="shoot()">Press on Grid</button>
    </div>
  </div>

</template>

<script>

  export default {

  name: 'Tictac',

  // props: [ "videoMov" ],

  data (){
    return {
      aim: {},
      button: {},
      target: '',
      buttonState: 'enabled',
      shootNum: 0,
      targetChoosed: false,
      virgin: true // first time play
    }
  },

  methods: {

    setTarget(point){

      this.aim = document.querySelector('.tictac .aim span')
      this.button = document.querySelector('.tictac button')

      if(this.buttonState == 'enabled'){

        this.target = point
        this.setActive(point)

        this.aim.innerHTML = point
        this.button.innerHTML = 'Confirm'
        this.button.classList.remove('inactive')

        this.targetChoosed = true
      } else {
        // alert('Buddy, you lost, try again')
      }



    },

    shoot(){
      if(this.buttonState == 'enabled' && this.targetChoosed){
        document.getElementById(this.target).classList.add('you')
        document.getElementById('B1').classList.add('snake')
        this.nextShoot()
      }

      else {
       this.$emit('gameOver', 'meow-tictactoe-death')
       // this.restart()
      }

      this.virgin = false
    },

    nextShoot(){

      let points = document.querySelectorAll(".tictac  .point");

      for (var i = 0; i < points.length; i++) {
        points[i].classList.remove('active')
      }

      // 1st shoot - win
      if(this.shootNum == 0 && this.target == 'B2'){
        
        console.log('win1')
        // document.getElementById('B2').classList.remove('active')

        return this.buttonState == 'enabled',
          this.shootNum = 1,
          this.button.classList.add('inactive'),
          this.button.innerHTML = 'Choose next target',
          this.aim.innerHTML = ''
      }

      // 1st shoot - lost
      if(this.shootNum == 0 && this.target != 'B2'){
        return this.buttonState = 'lost',
          document.querySelector('.tictac .shooter').classList.add('opacity0'),
          this.aim.innerHTML = 'Snake won 😿',
          this.button.innerHTML = 'Try Again',
          console.log('lost1')
      }

      // 2nd shoot - lost
      if(this.shootNum == 1 && this.target != 'A2'){
        return this.buttonState = 'lost',
          document.querySelector('.tictac .shooter').classList.add('opacity0'),
          this.aim.innerHTML = 'Snake won 😿',
          this.button.innerHTML = 'Try Again',
          console.log('lost2')
      }

      // 2nd shoot - win
      if(this.shootNum == 1 && this.target == 'A2'){
        // console.log('victory')
        return this.victory()
      }

      if (this.shootNum == 2){
        this.$emit('gameOver', 'meow-017')
      }
    },

    setActive(point){
      if(!this.targetChoosed){
        document.getElementById(point).classList.add('active')
      } else { 

          let points = document.querySelectorAll(".tictac .point");

          for (var i = 0; i < points.length; i++) {
            points[i].classList.remove('active')
          }

          document.getElementById(point).classList.add('active')

        }
    },

    victory(){
      
      this.buttonState == 'win'
      this.shootNum = 2

      // document.getElementById('A2').classList.remove('active')

      document.querySelector('.tictac .grid').classList.add('won')
      this.button.classList.add('inactive')
      this.button.innerHTML = 'One moment'

      setTimeout(function(){
        document.querySelector('.tictac button').innerHTML = 'Oh Yeah!'
        document.querySelector('.tictac .shooter').classList.add('opacity0')
        document.querySelector('.tictac .aim').innerHTML = 'CAT WON! 🤘'
        document.querySelector('.tictac button').classList.remove('inactive')
      }, 2500)


    },

    restart(){

      
      console.log('tictac restart')

      this.aim = {}
      this.button = {}
      this.target = ''
      this.buttonState = 'enabled'
      this.shootNum = 0
      this.targetChoosed = false

     
      let points = document.querySelectorAll(".tictac .point")
      document.querySelector(".tictac button").innerHTML = 'Press on Grid'

      for (var i = 0; i < points.length; i++) {
        points[i].classList.remove('active')
        points[i].classList.remove('you')
      }

      setTimeout(function(){ 
        document.querySelector("#B1").classList.remove('snake')
        document.querySelector("#C2").classList.add('you')
        document.querySelector("#A1").classList.add('baby')
        document.querySelector("#C1").classList.add('snake')
       }, 1);
      
    }

  },

  watch: { 

  },

  created(){

    if(!this.virgin){
      this.restart()
    }

      this.$ga.event({
        eventCategory: 'Tictactoe',
        eventAction: 'Tictactoe',
        eventValue: this.$store.state.player.adChance
      }) 

  },

  mounted: function (){
  }
}
</script>